import { ReportResponseSectionTypename } from 'chatspot-core/__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';
export { ReportResponseSectionTypename };
const pluginRegistry = new Map();
export function registerSectionFormatter(typename, renderer) {
  if (pluginRegistry.has(typename)) {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error(`[SectionFormatter] A formatter for typename "${typename}" is already registered`);
    } else {
      console.warn(`[SectionFormatter] A formatter for typename "${typename}" is already registered. Overwriting.`);
    }
  }
  pluginRegistry.set(typename, renderer);
}

/** Returns a renderer registered via registerSectionFormatter, or null if none. */
export function resolveExternalSectionFormatter(typename) {
  var _pluginRegistry$get;
  return (_pluginRegistry$get = pluginRegistry.get(typename)) !== null && _pluginRegistry$get !== void 0 ? _pluginRegistry$get : null;
}

/** @__test_only__ Clear all registered formatters. Do not call in production code. */
export function __resetSectionFormatterRegistryForTests() {
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  pluginRegistry.clear();
}